/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlInfoTrackSetupStateFieldsFragment = {
  __typename: "InfoTrackSetupState";
  authorized: boolean;
};

export const InfoTrackSetupStateFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "infoTrackSetupStateFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "InfoTrackSetupState" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "authorized" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlInfoTrackSetupStateFieldsFragment, unknown>;
